import ValueFilter from './ValueFilter';

interface StatusRangeFilterValue {
  type?: string;
  start?: string;
  end?: string;
}

class StatusRangeFilter extends ValueFilter<StatusRangeFilterValue> {
  toBookmarkConfiguration() {
    return this.getValue();
  }

  set(value: StatusRangeFilterValue) {
    super.set(value ?? {});
  }

  get type() {
    const value = this.getValue();
    return value.type;
  }

  get start() {
    const value = this.getValue();
    return value.start;
  }

  get end() {
    const value = this.getValue();
    return value.end;
  }
}

export default StatusRangeFilter;
